import React from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
export function MobileLayout() {
  return <div className="min-h-screen bg-gray-100 flex justify-center w-full" data-id="element-47">
      {/* Mobile Frame Container */}
      <div className="w-full max-w-md bg-brand-background min-h-screen relative shadow-2xl overflow-hidden flex flex-col" data-id="element-48">
        {/* Main Content Area - scrollable */}
        <main className="flex-1 overflow-y-auto hide-scrollbar pb-20" data-id="element-49">
          <Outlet data-id="element-50" />
        </main>

        {/* Fixed Bottom Navigation */}
        <BottomNav data-id="element-51" />
      </div>
    </div>;
}